import React from "react";
import { Layout } from 'antd';
import { connect, useDispatch } from 'react-redux';
import { SIDE_NAV_WIDTH, SIDE_NAV_DARK, NAV_TYPE_SIDE } from 'constants/ThemeConstant';
import { Scrollbars } from 'react-custom-scrollbars';
import { toggleCollapsedNav } from 'store/slices/themeSlice';
import MenuContent from './MenuContent'

const { Sider } = Layout;

export const SideNav = ({ navCollapsed, sideNavTheme, routeInfo, hideGroupTitle, localization = true, isMobile }) => {
  const dispatch = useDispatch();
  const props = { sideNavTheme, routeInfo, hideGroupTitle, localization };

  const handleMouseEnter = () => {
    if (!isMobile && navCollapsed) {
      dispatch(toggleCollapsedNav(false));
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile && !navCollapsed) {
      dispatch(toggleCollapsedNav(true));
    }
  };

  return (
    <Sider 
      className={`side-nav ${sideNavTheme === SIDE_NAV_DARK? 'side-nav-dark' : ''}`} 
      width={SIDE_NAV_WIDTH} 
      collapsed={navCollapsed}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Scrollbars autoHide>
        <MenuContent
          type={NAV_TYPE_SIDE}
          navCollapsed={navCollapsed}
          {...props}
        />
      </Scrollbars>
    </Sider>
  )
}

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, sideNavTheme } =  theme;
  return { navCollapsed, sideNavTheme }
};

export default connect(mapStateToProps)(SideNav);
